module.exports = __webpack_public_path__ + "img/discord.99e65b43.svg";